export class PlaidUtils {

  static getColorFromName(name: string): string {
    const hash = name.split('').reduce((acc, char) => {
      return char.charCodeAt(0) + ((acc << 5) - acc);
    }, 0);

    return Array.from({ length: 3 }, (_, i) => {
      const value = (hash >> (i * 8)) & 0xFF;
      return ('00' + value.toString(16)).slice(-2);
    }).reduce((color, hex) => color + hex, '#');
  }

}
